import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FileInfo } from "src/app/core/models/file-to-upload";
import { LoggingService } from "src/app/core/services/logging.service";
import { UploadProgress } from "src/app/core/models/upload-progress";
import { UploadStatus } from "src/app/core/models/upload-status";
import { SkuManagementService } from "../sku-management.service";

@Component({
    selector: "app-sku-file-upload",
    templateUrl: "./sku-file-upload.component.html",
    styleUrls: ["./sku-file-upload.component.scss"],
    standalone: false
})
export class SkuFileUploadComponent implements OnInit {
  selectedFile: FileInfo;
  lastUploaded: FileInfo;
  uploading: boolean;
  error: string;
  spinnerMode: string;
  uploadStatus: string;
  spinnerValue: number;

  @ViewChild("skuFileUploadInput", { static: true }) skuFileUploadInput: ElementRef;
  @Output() handleUploadResponse: EventEmitter<any> = new EventEmitter<any>();

  constructor(private skuManagementService: SkuManagementService) {}

  ngOnInit() {}

  uploadSkuFile() {
    this.uploading = true;
    this.error = null;
    this.lastUploaded = null;
    this.uploadStatus = null;
    this.spinnerMode = "determinate";
    this.spinnerValue = 0;

    const input = this.skuFileUploadInput.nativeElement;
    const file = input.files[0];

    this.skuManagementService.uploadFile$(file).subscribe(
      (progress: UploadProgress) => {
        if (progress.status == UploadStatus.Progress) {
          if (progress.progress === 100) {
            this.spinnerMode = "indeterminate";
            this.uploadStatus = "Processing...";
          } else {
            this.spinnerMode = "determinate";
            this.uploadStatus = "Uploading...";
          }
          this.spinnerValue = progress.progress;
        } else if (progress.status == UploadStatus.Complete) {
          this.uploading = false;
          this.lastUploaded = this.selectedFile;
          this.selectedFile = null;
          this.skuFileUploadInput.nativeElement.value = "";

          if (this.handleUploadResponse) {
            this.handleUploadResponse.emit(progress.response);
          }
        }
      },
      err => {
        this.uploading = false;
        this.error = err;
      },
      () => {
        LoggingService.log("sku upload complete");
      },
    );
  }

  onFileSelected() {
    const input = this.skuFileUploadInput.nativeElement;
    const file = input.files[0];

    this.lastUploaded = null;
    this.error = null;

    if (file) {
      this.selectedFile = {
        name: file.name,
        size: file.size,
        lastModified: file.lastModified,
      };
    } else {
      this.selectedFile = null;
    }
  }
}
